<template>
    <div class="date-selected-container">
        <div id="calendar-box" class="form-group date-selected"
            v-bind:class="{ 'dark': this.getDesign() == 'black', 'white': this.getDesign() == 'white' }">
            <label for="">{{ $t('Fechas y horas disponibles') }}</label>
            <div 
            class="input-select" 
            :class="{ 'no-icon': searchSchedule }"
            @click="!searchSchedule && openCalendar()" >
                {{ getDateSelected() }}
            </div>
            <div v-show="showCalendarBox" class="calendar-box">
                <calendar @date-selected="dateSelected" @date-selected-click="dateSelectedClick"
                    :experience="experience" type="minimal" />
            </div>
        </div>

        <div id="schedules-box" class="form-group schedule-selected"
            v-bind:class="{ 'dark': this.getDesign() == 'black', 'white': this.getDesign() == 'white' }">
            <div class="input-select" @click="showScheduleBox = (searchSchedule) ? false : !showScheduleBox">
                {{ getItemsExperience }}
            </div>
            <div v-show="showScheduleBox" class="schedule-box">
                <minimal-schedules :key="keySchedules" :number-players="numberPlayers" :experience="experience"
                    :call="call" @schedule-selected="scheduleSelected" @schedule-loaded="onScheduleLoaded" />
            </div>
        </div>
    </div>

</template>

<script>
import { mapMutations } from 'vuex';
import { mapGetters } from 'vuex';

import Calendar from '../calendar/calendar.vue';
import MinimalSchedules from '../minimal-schedules/minimal-schedules.vue'

export default {
    name: 'date-selected',
    props: ['numberPlayers', 'experience', 'call'],
    components: { Calendar, MinimalSchedules },
    data() {
        return {
            showCalendarBox: false,
            showScheduleBox: false,
            searchSchedule: true,
            keySchedules: 0,
            simulatedClick: false
        }
    },
    computed: {
        ...mapGetters(['getDateSelected', 'getDesign', 'getCheckout', 'getCalendarDays']),
        getItemsExperience: function () {
            if (this.searchSchedule) {
                this.getCheckout().items[0].start = null;
                return this.$t('Buscando disponibilidad...');
            }
            else if (this.getCheckout().items[0].start) {
                return this.getCheckout().items[0].startHour;
            }
            else {
                return this.$t('Seleccione una hora');
            }
        }
    },
    methods: {
        ...mapMutations(['updateDateSelected']),
        dateSelected: function (dateSelected) {
            const currentDate = this.getDateSelected();

            /*
            En onScheduleLoaded simula clicks para buscar
            el primer días con disponibilidad 
            pero la mismo tiempo se llama esto 
            para evitar que se salte dias no se tiene 
            en cuenta si sin clicks simualdos
            */
            if (!this.simulatedClick) {
                this.updateDateSelected({ dateSelected: dateSelected, notUpdateCheckout: true });
            }

            /*
            Cuando la fecha se actualiza de forma automática (por ejemplo,
            al volver desde el checkout y el calendario selecciona el día actual),
            se debe recargar el listado de horarios para esa nueva fecha.
            */
            if (currentDate !== dateSelected) {
                this.searchSchedule = true;
                this.showScheduleBox = false;
                this.keySchedules++;
            }
        },
        dateSelectedClick: function (dateSelected) {
            this.showCalendarBox = false;
            this.showScheduleBox = false;
            this.searchSchedule = true;
            this.updateDateSelected({ dateSelected: dateSelected, notUpdateCheckout: true });
            this.keySchedules++;
        },
        openCalendar: function () {
            this.showCalendarBox = !this.showCalendarBox;
            document.getElementById("calendar-box").scrollIntoView(true);
        },
        notAvailableDay: function (notAvailableDay) {
            this.notAvailableDayShow = notAvailableDay;
        },
        scheduleSelected: function () {
            this.showScheduleBox = false;
        },
        onScheduleLoaded: function (schedules) {
            this.searchSchedule = false;
            this.showScheduleBox = true;


            const dateSelected = this.getDateSelected();
            const calendarDay = this.getCalendarDays()[dateSelected];

            /*
            Si no hay disponibilidad ese día se pasa al 
            día siguiente pero como esto es un lio lo unico
            que hace que funcione es simular que se le da click al día
            */
            if (schedules.length === 0 || (calendarDay && calendarDay.total === 0 || (calendarDay?.occupied >= calendarDay?.total))) {
                let nextDay = this.getNextDay(this.getDateSelected());
                this.simulatedClick = true;
                this.dateSelectedClick(nextDay);
            } else {
                this.simulatedClick = false;
            }
        },
        getNextDay(dateString) {
            let parts = dateString.split("/");
            let date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
            date.setDate(date.getDate() + 1);
            let nextDay = date.getDate().toString().padStart(2, '0');
            let nextMonth = (date.getMonth() + 1).toString().padStart(2, '0');
            let nextYear = date.getFullYear();
            return `${nextDay}/${nextMonth}/${nextYear}`;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_variables_white.scss";
@import "@/scss/_variables_dark.scss";

@import "date-selected";

.no-icon {
    background-image: none!important;
}
</style>
